import { addDoc, collection, doc, getDoc, getDocs, query, Timestamp, where } from 'firebase/firestore';
import { db } from '../../firebaseConfig';
import { docsWithId } from '../db';

// Reads and writes behind Admin → System health diagnostics. The scan audits whole
// collections, so these are deliberately unfiltered reads.

/** One small admin-only read, to time database latency. */
export async function pingDatabase() {
  await getDoc(doc(db, 'admin_settings', 'loops'));
}

/** Every document of each named collection: { [name]: [{ id, ...data }] }. Admin dashboards and diagnostics only. */
export async function readAdminCollections(names) {
  const snapshots = await Promise.all(names.map((name) => getDocs(collection(db, name))));
  return Object.fromEntries(names.map((name, index) => [name, docsWithId(snapshots[index])]));
}

export function saveDiagnosticReport(report) {
  return addDoc(collection(db, 'admin_diagnostics'), { ...report, createdAt: Timestamp.now() });
}

/** Whether this profile already has an unread system alert. */
export async function hasUnreadSystemAlert(recipientId) {
  const snapshot = await getDocs(query(collection(db, 'notifications'),
    where('recipientId', '==', recipientId), where('type', '==', 'system_alert')));
  return snapshot.docs.some((snap) => !snap.data().seen);
}
